import { Input, HostBinding, Directive, Inject, PLATFORM_ID, ElementRef, NgModule } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser, CommonModule } from '@angular/common';

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
let HeadDescriptionDirective = class HeadDescriptionDirective {
    constructor(el, metaService, platformId) {
        this.el = el;
        this.metaService = metaService;
        this.platformId = platformId;
        this.onlyDescription = false;
        this.baseMetas = [
            {
                name: 'twitter:description',
            },
            {
                property: 'og:description',
            },
            {
                itemprop: 'description',
            },
        ];
        this.display = 'none';
        this.metaElements = [];
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    this.clean();
                    this.init(mutation.target.textContent);
                });
            });
            this.observer.observe(this.el.nativeElement, {
                characterData: false,
                attributes: false,
                childList: true,
                subtree: false,
            });
        }
    }
    ngAfterViewInit() {
        const description = this.el.nativeElement.textContent.trim();
        this.metaElements = [
            this.metaService.addTag({
                name: 'description',
                content: description,
            }),
        ];
        if (!this.onlyDescription) {
            this.metaElements = [
                ...this.metaElements,
                ...this.metaService.addTags(this.baseMetas.map(meta => (Object.assign({}, meta, { content: description })))),
            ];
        }
    }
    ngOnDestroy() {
        this.clean();
        if (isPlatformBrowser(this.platformId)) {
            this.observer.disconnect();
        }
    }
    clean() {
        this.metaElements.forEach(meta => {
            this.metaService.removeTagElement(meta);
        });
    }
    init(textContent) {
        const description = textContent.trim();
        this.metaElements = [
            this.metaService.addTag({
                name: 'description',
                content: description,
            }),
        ];
        if (!this.onlyDescription) {
            this.metaElements = [
                ...this.metaElements,
                ...this.metaService.addTags(this.baseMetas.map(meta => (Object.assign({}, meta, { content: description })))),
            ];
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeadDescriptionDirective.prototype, "onlyDescription", void 0);
__decorate([
    HostBinding('style.display'),
    __metadata("design:type", Object)
], HeadDescriptionDirective.prototype, "display", void 0);
HeadDescriptionDirective = __decorate([
    Directive({
        selector: 'span[wizHeadDescription]',
    }),
    __param(2, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [ElementRef,
        Meta,
        Object])
], HeadDescriptionDirective);

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let HeadDescriptionModule = class HeadDescriptionModule {
};
HeadDescriptionModule = __decorate$1([
    NgModule({
        declarations: [HeadDescriptionDirective],
        imports: [CommonModule],
        exports: [HeadDescriptionDirective],
    })
], HeadDescriptionModule);

var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param$1 = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
let HeadTitleDirective = class HeadTitleDirective {
    constructor(el, titleService, metaService, platformId) {
        this.el = el;
        this.titleService = titleService;
        this.metaService = metaService;
        this.platformId = platformId;
        this.display = 'none';
        this.baseMetas = [
            {
                name: 'twitter:title',
            },
            {
                property: 'og:title',
            },
        ];
        this.metaElements = [];
    }
    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.observer = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    this.clean();
                    this.init(mutation.target.textContent);
                });
            });
            this.observer.observe(this.el.nativeElement, {
                characterData: false,
                attributes: false,
                childList: true,
                subtree: false,
            });
        }
    }
    ngAfterViewInit() {
        this.init(this.el.nativeElement.textContent);
    }
    ngOnDestroy() {
        this.clean();
        if (isPlatformBrowser(this.platformId)) {
            this.observer.disconnect();
        }
    }
    clean() {
        this.metaElements.forEach(meta => {
            this.metaService.removeTagElement(meta);
        });
    }
    init(textContent) {
        const title = textContent.trim();
        this.metaElements = [
            this.metaService.addTag({
                property: 'og:title',
                content: title,
            }),
            ...this.metaService.addTags(this.baseMetas.map(meta => (Object.assign({}, meta, { content: title })))),
        ];
        this.titleService.setTitle(title);
    }
};
__decorate$2([
    HostBinding('style.display'),
    __metadata$1("design:type", Object)
], HeadTitleDirective.prototype, "display", void 0);
HeadTitleDirective = __decorate$2([
    Directive({
        selector: 'span[wizHeadTitle]',
    }),
    __param$1(3, Inject(PLATFORM_ID)),
    __metadata$1("design:paramtypes", [ElementRef,
        Title,
        Meta, Object])
], HeadTitleDirective);

var __decorate$3 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let HeadTitleModule = class HeadTitleModule {
};
HeadTitleModule = __decorate$3([
    NgModule({
        declarations: [HeadTitleDirective],
        imports: [CommonModule],
        exports: [HeadTitleDirective],
    })
], HeadTitleModule);

export { HeadDescriptionDirective, HeadDescriptionModule, HeadTitleDirective, HeadTitleModule };
//# sourceMappingURL=wizbii-seo-lib.js.map
